import { Star } from 'lucide-react';

const testimonials = [
  {
    name: "María Rodriguez",
    role: "Madre de Juan, 9 años",
    content: "FinancieraMente ha transformado la manera en que mi hijo ve el dinero. Ahora entiende conceptos que yo hubiera querido aprender a su edad."
  },
  {
    name: "Carlos Mendoza",
    role: "Padre de Ana, 11 años",
    content: "Los juegos y actividades mantienen a mi hija enganchada mientras aprende. Es increíble ver cómo aplica lo aprendido en su día a día."
  },
  {
    name: "Laura Torres",
    role: "Madre de Diego, 10 años",
    content: "La plataforma es exactamente lo que buscaba para complementar la educación de mi hijo. Los conceptos financieros se explican de forma clara y divertida."
  }
];

export const Testimonials = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-primary/5">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary">
          Lo que dicen nuestras familias
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex flex-col mb-4">
                <h3 className="font-semibold text-lg">{testimonial.name}</h3>
                <p className="text-gray-600 text-sm">{testimonial.role}</p>
              </div>
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-700">{testimonial.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};